<div class="register-layout" >
  <div class="row form-layout py-4">
    <div class="col-md-10 form position-relative">
      <div class="mt-1">
        <div class="row">
          <form class="row g-3" [formGroup]="bankAccForm"  novalidate [ngClass]="loading ? 'blur-background' : ''">
            <div class="form-label ">
              <h2 class="dashboard-sub-heading">Add Bank Account</h2>
            </div>

            <hr>
            <div class="col-md-6 text-start" >
              <label for="bankAccBank" class="form-label">Bank</label>
              <select class="form-select" aria-label="Default select example"
                      formControlName="bankAccBank"
                      [ngClass]="{'is-invalid': AddBankAccSubmitted && formInstControl['bankAccBank'].errors}">
                <option [ngValue]="bank.bankId" *ngFor="let bank of bankList">
                  {{ bank.bankName }}
                </option>
              </select>
              <div *ngIf="AddBankAccSubmitted && formInstControl['bankAccBank'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['bankAccBank'].errors['required']">
                  Select a Bank
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="bankAccBranch" class="form-label">Branch</label>
              <input type="text" class="form-control" id="bankAccBranch"
                     formControlName="bankAccBranch"
                     [ngClass]="{ 'is-invalid': AddBankAccSubmitted && formInstControl['bankAccBranch'].errors }">
              <div *ngIf="AddBankAccSubmitted && formInstControl['bankAccBranch'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['bankAccBranch'].errors['required']">
                  Branch is required
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="bankAccNumber" class="form-label">Bank Account Number</label>
              <input type="number" step="0.01" class="form-control" id="bankAccNumber"
                     formControlName="bankAccNumber"
                     [ngClass]="{ 'is-invalid': AddBankAccSubmitted && formInstControl['bankAccNumber'].errors }">
              <div *ngIf="AddBankAccSubmitted && formInstControl['bankAccNumber'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['bankAccNumber'].errors['required']">
                  Bank Account Number is required
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="bankAccCurrency" class="form-label">Currency</label>
              <select class="form-select" aria-label="Default select example"
                      formControlName="bankAccCurrency"
                      [ngClass]="{'is-invalid': AddBankAccSubmitted && formInstControl['bankAccCurrency'].errors}">
                <option [ngValue]="currency.type" *ngFor="let currency of currencyList">
                  {{currency.type}} - {{currency.description}}
                </option>
              </select>
              <div *ngIf="AddBankAccSubmitted && formInstControl['bankAccCurrency'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['bankAccCurrency'].errors['required']">
                  Select a Currency
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="bankAccContactName" class="form-label">Contact Name</label>
              <input type="text" class="form-control" id="bankAccContactName"
                     formControlName="bankAccContactName"
                     [ngClass]="{ 'is-invalid': AddBankAccSubmitted && formInstControl['bankAccContactName'].errors }">
              <div *ngIf="AddBankAccSubmitted && formInstControl['bankAccContactName'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['bankAccContactName'].errors['required']">
                  Contact Name is required
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="contactNo" class="form-label">Contact Number</label>
              <div class=" row d-flex">
                <div class="col-md-3"><ngx-intl-tel-input
                  style="width: 2vw"
                  type="text"
                  id="contactNo"
                  formControlName="bankAccContactNumber"
                  [enablePlaceholder]="true"
                  [searchCountryFlag]="true"
                  [selectFirstCountry]="true"
                  [separateDialCode]="true"
                  [maxLength]="0"
                  [outerText]=""
                  [phoneValidation]="false"

                  [enableAutoCountrySelect]="true"
                ></ngx-intl-tel-input></div>

                <div class=" col-md-9 sl-flex-row" id="contactNum">
                  <!--              <input type="text" class="form-control" id="contactNoLoad" formControlName="contactNo"-->
                  <!--                     [ngClass]="{ 'is-invalid': submitted && formControl['contactNo'].errors }"-->
                  <!--                     [readonly]="role == 'admin'" [hidden]="role != 'admin'">-->
                  <input
                    placeholder="1234567"
                    class="form-control"
                    formControlName="contactNumber"
                  />
                  <div class="invalid-feedback">
                    <div>&nbsp;&nbsp;Contact Number is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-label add-form-checkBox" style=" padding: 10px">
              <input mdbCheckbox type="checkbox"  id="isDefault" formControlName="isDefault" [disabled]="isDefault == 'YES' ? true : false" />
              Is Default
            </div>
          </form>
        </div>
      </div>
      <div *ngIf="loading" class="position-absolute top-50 start-50 translate-middle">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div>
        <div class="row">
          <div class=" d-flex"  style="justify-content:flex-end;">
            <button class="btn btn-primary" style="margin-right: 20px;" (click)="modalRef.close()">Cancel</button>
            <button class="btn btn-primary" (click)="onClickAddBankAccount()" *ngIf="!isUpdate">ADD</button>
            <button class="btn btn-primary" (click)="onClickUpdateBankAccount()"  *ngIf="isUpdate && isFormDirty()">Update</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
